// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.context-menu {
    background-color: #fafafa;
    padding: 4pt;
    font-size: 10pt;
    z-index: 1000;
    box-shadow: 0 0 12pt rgba(0, 0, 0, 0.25);
    border-radius: 4pt;
    padding: 0.5em 0 0.5em 0;
    animation: fadeIn 0.1s ease-out;
    opacity: 1.0;
    display: block;
}

    .context-menu hr {
        border: none;
        border-bottom: 1px solid #eee;
    }

    .context-menu div {
        cursor: pointer;
        display: block;
        text-decoration: none;
        color: #333;
        /*padding: 0.5em 2em 0.5em 0.75em;
        max-width: 18em;*/
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

        .context-menu div:hover {
            background-color: #333;
            color: #fff;
        }


        .context-menu div::before {
            content: '';
            float: left;
            margin-right: 0.75em;
            width: 0.5em;
            /*height: 1em;*/
            display: inline-block;
        }



/* Animatinons */

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1.0;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1.0;
    }

    to {
        opacity: 0.0;
    }
}

.is-fadingIn {
    animation: fadeIn 0.1s ease-out;
    opacity: 1.0;
    display: block;
}

.is-fadingOut {
    animation: fadeOut 0.1s ease-out;
    opacity: 0.0;
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/contextmenu/contextmenu.component.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,YAAY;IACZ,cAAc;AAClB;;IAEI;QACI,YAAY;QACZ,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,cAAc;QACd,qBAAqB;QACrB,WAAW;QACX;yBACiB;QACjB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;QAEI;YACI,sBAAsB;YACtB,WAAW;QACf;;;QAGA;YACI,WAAW;YACX,WAAW;YACX,oBAAoB;YACpB,YAAY;YACZ,eAAe;YACf,qBAAqB;QACzB;;;;AAIR,gBAAgB;;AAWhB;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;AAYA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IAEI,+BAA+B;IAC/B,YAAY;IACZ,cAAc;AAClB;;AAEA;IAEI,gCAAgC;IAChC,YAAY;IACZ,cAAc;AAClB","sourcesContent":["\n.context-menu {\n    background-color: #fafafa;\n    padding: 4pt;\n    font-size: 10pt;\n    z-index: 1000;\n    box-shadow: 0 0 12pt rgba(0, 0, 0, 0.25);\n    border-radius: 4pt;\n    padding: 0.5em 0 0.5em 0;\n    animation: fadeIn 0.1s ease-out;\n    opacity: 1.0;\n    display: block;\n}\n\n    .context-menu hr {\n        border: none;\n        border-bottom: 1px solid #eee;\n    }\n\n    .context-menu div {\n        cursor: pointer;\n        display: block;\n        text-decoration: none;\n        color: #333;\n        /*padding: 0.5em 2em 0.5em 0.75em;\n        max-width: 18em;*/\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n        .context-menu div:hover {\n            background-color: #333;\n            color: #fff;\n        }\n\n\n        .context-menu div::before {\n            content: '';\n            float: left;\n            margin-right: 0.75em;\n            width: 0.5em;\n            /*height: 1em;*/\n            display: inline-block;\n        }\n\n\n\n/* Animatinons */\n@-webkit-keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1.0;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1.0;\n    }\n}\n\n@-webkit-keyframes fadeOut {\n    from {\n        opacity: 1.0;\n    }\n\n    to {\n        opacity: 0.0;\n    }\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1.0;\n    }\n\n    to {\n        opacity: 0.0;\n    }\n}\n\n.is-fadingIn {\n    -webkit-animation: fadeIn 0.1s ease-out;\n    animation: fadeIn 0.1s ease-out;\n    opacity: 1.0;\n    display: block;\n}\n\n.is-fadingOut {\n    -webkit-animation: fadeOut 0.1s ease-out;\n    animation: fadeOut 0.1s ease-out;\n    opacity: 0.0;\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
